import { useFormat } from '@ideavivat/vivat-2';

import {
  _increment,
  _deliveredControls,
  code,
  name,
  count,
  unit,
  totalWeight,
  deliveryFeeRate,
  deliveryFee,
  _remarksControls,
} from './base';

export default {
  types: {
    _increment,
    _deliveredControls,
    code,
    name,
    // count: {
    //   name: 'จำนวน (บรรจุ)',
    //   width: '4rem',
    //   filter: (val: string, row: any) => toDecimalFormat(row.item.count),
    //   class: {
    //     cell: 'text-center',
    //     text: 'text-right',
    //   },
    // },
    count,
    unit,
    totalWeight,
    deliveryFeeRate,
    deliveryFee,
    _remarksControls,
    // width: {
    //   name: 'กว้าง',
    //   width: '6rem',
    // },
    // length: {
    //   name: 'ยาว',
    //   width: '3rem',
    // },
    // height: {
    //   name: 'สูง',
    //   width: '3rem',
    // },
  },
};
